import React from 'react';
import { classNames } from 'primereact/utils';
import { InputTextarea } from 'primereact/inputtextarea';
import { FormField } from '../../FormField/FormField';
import { ReservationFormFieldProps } from '../types';

interface Props extends ReservationFormFieldProps {
  isEditable: boolean;
}

/** A free comment about the reservation. */
export const CommentField = ({ form, setFormFields, validationErrors, isEditable }: Props) => {
  return (
    <FormField labelTitle='Comentario' elementId='reservation-comment' fullWidth error={validationErrors?.comment}>
      {isEditable ? (
        <InputTextarea
          id='reservation-comment'
          className={classNames({
            'p-invalid': validationErrors?.comment,
          })}
          placeholder={`Escribe un comentario sobre la reserva`}
          autoResize
          value={form?.comment ?? ''}
          onChange={(e: any) =>
            setFormFields({
              comment: e.target.value,
            })
          }
          rows={3}
        />
      ) : (
        <p>{form?.comment || '-'}</p>
      )}
    </FormField>
  );
};
